var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ConversationsStraightIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M45.6522 8.69565C45.6522 6.29348 43.7065 4.34783 41.3043 4.34783H8.69565C6.29348 4.34783 4.34783 6.29348 4.34783 8.69565V31.5217C4.34783 33.9239 6.29348 35.8696 8.69565 35.8696H13.0435V42.3261L22.7609 36.4891L23.7935 35.8696H41.3043C43.7065 35.8696 45.6522 33.9239 45.6522 31.5217V8.69565ZM8.69565 0H41.3043C46.1087 0 50 3.8913 50 8.69565V31.5217C50 36.3261 46.1087 40.2174 41.3043 40.2174H25L8.69565 50V40.2174C3.8913 40.2174 0 36.3261 0 31.5217V8.69565C0 3.8913 3.8913 0 8.69565 0ZM24.9999 16.3043C22.5978 16.3043 20.6521 18.25 20.6521 20.6522C20.6521 23.0543 22.5978 25 24.9999 25C27.4021 25 29.3478 23.0543 29.3478 20.6522C29.3478 18.25 27.4021 16.3043 24.9999 16.3043ZM33.6956 20.6522C33.6956 18.25 35.6412 16.3043 38.0434 16.3043C40.4456 16.3043 42.3912 18.25 42.3912 20.6522C42.3912 23.0543 40.4456 25 38.0434 25C35.6412 25 33.6956 23.0543 33.6956 20.6522ZM11.9565 16.3043C9.55429 16.3043 7.60864 18.25 7.60864 20.6522C7.60864 23.0543 9.55429 25 11.9565 25C14.3586 25 16.3043 23.0543 16.3043 20.6522C16.3043 18.25 14.3586 16.3043 11.9565 16.3043Z",
    fill: "black"
  }));
};
export var ConversationsStraightIconGlyph = function (props) {
  return React.createElement(ConversationsStraightIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};